// extracted by mini-css-extract-plugin
export default {"wrapper":"OrganizationsList_wrapper__BUxLX"};